import * as React from 'react';
import classNames from 'classnames';
import { omit, uniqueId } from 'lodash';
import {Popover2} from '@blueprintjs/popover2';
import Button, {IButtonProps} from '../Button';
import Buttons from '../Buttons';

export interface IFilterDropProps {
    /** Render as fieldset */
    isFieldSet?: boolean;
    /** Display as list */
    isList?: boolean;
    /** How to position the popover */
    position?: any;
    /** How to position the popover */
    boundary?: 'scrollParent' | 'viewport' | 'window';
    /** Offset the popover */
    offset?: string;
    /** Click event to bind to toggler */
    onClick?: (event) => void;
    /** Toggler */
    toggler: string | React.ReactNode;
    /** Display arrow in toggler */
    arrow?: React.ReactNode;
    /** Additional classnames */
    contentClassName?: string;
    portalClassName?: string;
    popoverClassName?: string;
    togglerClassName?: string;
    flip?: boolean;
    submitButton?: IButtonProps;
}


/**
 * Renders DOM string to clickable link.
 */
const FilterDrop: React.FunctionComponent<IFilterDropProps> = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClosePopover = () => {
        setOpen(false);
    };

    const handleTogglerKeypress = (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setOpen(true);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            setOpen(true);
        }
    };
    const id = uniqueId('filterdrop');

    // Main output
    const WrapperElem = props.isFieldSet ? 'fieldset' : 'div';
    const TogglerElem = props.isFieldSet ? 'legend' : 'a';

    return (
        <WrapperElem>
            <Popover2
                enforceFocus={true}
                // interactionKind={PopoverInteractionKind.HOVER}
                placement={props.position ? props.position : 'bottom-start'}
                usePortal={false}
                minimal={true}
                autoFocus={true}
                isOpen={open}
                onClose={handleClosePopover}
                modifiers={{
                    flip: {
                        enabled: props.flip ? props.flip : false,
                    },
                }}
                portalClassName={classNames('site-menu-portal', props.portalClassName && props.portalClassName)}
                popoverClassName={classNames('site-menu-popover', props.popoverClassName && props.popoverClassName)}
                content={(
                    <React.Fragment>
                        {
                            props.isList ? (
                                <ul id={id} className={classNames('site-menu-items', props.contentClassName)}>
                                    {React.Children.map(props.children, (child: any, i) => {
                                        return (
                                            <li key={i}>
                                                {child}
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <div id={id}>
                                    {React.Children.map(props.children, (child: any, i) => {
                                        return child;
                                    })}
                                </div>
                            )
                        }
                        {
                            props.submitButton && (
                                <Buttons>
                                    <Button onClick={(e) => {
                                        setOpen(false);
                                        if (props.submitButton && props.submitButton.onClick) {
                                            props.submitButton.onClick(e);
                                        }
                                    }} {...omit(props.submitButton, 'onClick')}/>
                                </Buttons>
                            )
                        }
                    </React.Fragment>
                )}
                transitionDuration={0}
                hoverOpenDelay={0}
                hoverCloseDelay={100}
            >
                <TogglerElem
                    className={classNames('toggler', props.togglerClassName)}
                    suppressHydrationWarning={true}
                    tabIndex={0}
                    role="button"
                    aria-controls={id}
                    aria-expanded={open}
                    aria-haspopup="listbox"
                    onClick={(e) => {
                        e.preventDefault();
                        setOpen(true);
                    }}
                    onKeyPress={(e) => {
                        handleTogglerKeypress(e);
                    }}
                >
                    <span className="toggle-text">{props.toggler}</span>
                    {props.arrow && (<span className="toggle-icon">{props.arrow}</span>)}
                </TogglerElem>
            </Popover2>

        </WrapperElem>
    );
};

FilterDrop.displayName = 'FilterDrop';

export default FilterDrop;
